import { Button } from "baseui/button"
import { ButtonGroup } from "baseui/button-group"
import { useState } from "react"
import { FormattedMessage } from "react-intl"

const TotalOrSqmSelector = (props: { byM2: boolean, onByM2Changed: (value: boolean) => void}) => {

    const [sqm, setSqm] = useState(props.byM2)

    const handleSetSqm = (value: boolean) => {
        setSqm(value);
        props.onByM2Changed(value);
    }
    return (<ButtonGroup kind="secondary" size="compact" >
        <Button onClick={() => handleSetSqm(false)} isSelected={!sqm}><FormattedMessage id="Total" defaultMessage={'Total'}></FormattedMessage></Button>
        <Button onClick={() => handleSetSqm(true)} isSelected={sqm}><FormattedMessage id="perM2" defaultMessage={'per m²'}></FormattedMessage></Button>
    </ButtonGroup>)
}

export default TotalOrSqmSelector